import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeBossQuery from "@saleor/hooks/makeBossQuery";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import {
  InitialStoresReportFilterData,
  InitialStoresReportFilterDataVariables
} from "./types/InitialStoresReportFilterData";
import { StoresReport, StoresReportVariables } from "./types/StoresReport";

export const StoresReportList = gql`
  ${pageInfoFragment}
  query StoresReport(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: StoreDetailsFilterInput!
  ) {
    storeDetails(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
    ) {
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
        node {
          id
          mall_name
          brand_name
          legal_name
          store_type
          store_status
          contract_id
          rental_type
          vertical
        }
      }
    }
  }
`;

export const useStoresQuery = makeBossQuery<
  StoresReport,
  StoresReportVariables
>(StoresReportList);

export const StoresReportDownload = gql`
  ${pageInfoFragment}
  query StoresReportDownload(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: StoreDetailsFilterInput!
  ) {
    storeDetails(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
    ) {
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
        node {
          id
          mall_name
          brand_name
          legal_name
          store_type
          store_status
          contract_id
          rental_type
          vertical
        }
      }
    }
  }
`;

export const initialStoresReportFilterDataQuery = gql`
  query InitialStoresReportFilterData($brand: [ID], $mall: [ID]) {
    brands(first: 5, filter: { id: $brand }) {
      edges {
        node {
          id
          name
        }
      }
    }

    malls(first: 5, filter: { id: $mall }) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

export const useInitialStoresReportFilterDataQuery = makeQuery<
  InitialStoresReportFilterData,
  InitialStoresReportFilterDataVariables
>(initialStoresReportFilterDataQuery);
